// Loan amounts carry 2 decimal places. The booking stores one decimal value; a Loan Tracker
// bank case exposes `loanAmount` (whole-ringgit floor, an integer string kept for older clients)
// and `loanAmountDecimal` ("350000.55"). mhub-api rejects a decimal inside `loanAmount`, so
// anything sent to a bank case must split the value into those two fields.

export const roundLoanAmount = (value) => {
  const amount = parseFloat(value);
  if (!Number.isFinite(amount) || amount <= 0) {
    return 0;
  }
  return Math.round(amount * 100) / 100;
};

export const bankCaseLoanAmount = (bankCase) => {
  if (!bankCase) {
    return 0;
  }
  if (bankCase.loanAmountDecimal !== undefined && bankCase.loanAmountDecimal !== null && bankCase.loanAmountDecimal !== '') {
    return roundLoanAmount(bankCase.loanAmountDecimal);
  }
  return roundLoanAmount(bankCase.loanAmount);
};

const toCents = (value) => {
  const amount = parseFloat(value);
  if (!Number.isFinite(amount) || amount <= 0) {
    return 0;
  }
  return Math.round(amount * 100);
};

// Margin as a whole percent, rounded up like the existing screens. Both amounts are taken in
// integer cents: a float division such as 12000.12 / 100001 lands a hair above 0.12 and the
// round-up would report 13% for an exact 12%.
export const loanMarginPercent = (loanAmount, spaValue) => {
  const loan = toCents(loanAmount);
  const spa = toCents(spaValue);
  if (spa <= 0 || loan <= 0) {
    return 0;
  }
  return Math.ceil((loan * 100) / spa);
};

// Amount for a margin, rounded down to the cent so it never exceeds the margin's share. The
// selling price is taken in integer cents and multiplied before dividing, because dividing the
// percentage first (0.29 * 100000) loses a cent to floating point.
export const loanAmountFromMargin = (percent, spaValue) => {
  const spa = toCents(spaValue);
  const margin = parseFloat(percent);
  if (spa <= 0 || !(margin >= 0)) {
    return 0;
  }
  return Math.floor((spa * margin) / 100) / 100;
};

export const bankCaseLoanAmountPayload = (value) => {
  const amount = roundLoanAmount(value);
  return {
    loanAmount: `${Math.floor(amount)}`,
    loanAmountDecimal: amount.toFixed(2),
  };
};



// WEBPACK FOOTER //
// ./src/utils/loanAmount.js